/* Archival redesign: product page behavior (sections/aa-main-product.liquid)
 * - option state (color swatches, size chips) -> variant, price, URL, availability, gallery
 * - add to cart via /cart/add.js, then theme:cart:refresh so Palo Alto's cart drawer opens
 * - size chart drawer, zoom overlay, mobile sticky bar + size sheet
 * Intentionally no button[name="add"], [data-add-to-cart] or options[Size] inputs (old size guard selectors). */
(function () {
  var HERO_SIZES = '(min-width: 1200px) 57vw, (min-width: 750px) 42vw, 92vw', TILE_SIZES = '(min-width: 1200px) 28vw, (min-width: 750px) 42vw, 92vw';
  'use strict';

  // keep in sync with snippets/aa-size-word.liquid
  var SIZE_WORDS = { XS: 'extra small', S: 'small', M: 'medium', L: 'large', XL: 'extra large', '2XL': '2x large', XXL: '2x large', '3XL': '3x large', XXXL: '3x large', '4XL': '4x large', '5XL': '5x large', OS: 'one size', 'ONE SIZE': 'one size' };
  function sizeWord(val) {
    var v = String(val).trim().toUpperCase(), pre = '';
    if (v.length > 1 && v.charAt(0) === 'Y' && SIZE_WORDS[v.slice(1)]) { pre = 'youth '; v = v.slice(1); }
    return SIZE_WORDS[v] ? pre + SIZE_WORDS[v] : String(val).toLowerCase();
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  // "a size", "a color", "an amount" (gift card denominations)
  function chooseWord(name) {
    var n = String(name || 'size').toLowerCase();
    return /denomination|amount/.test(n) ? 'an amount' : 'a ' + n;
  }
  // heavyweight colors carry a "vintage" prefix (vintage black) the classic tee's (black) lacks
  function normColor(c) { return String(c || '').toLowerCase().replace(/^vintage\s+/, '').trim(); }
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  function Pdp(root) {
    if (root.__aaPdp) return;
    root.__aaPdp = this;
    var self = this;
    var jsonEl = $('[data-aa-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    this.root = root;
    this.data = data;
    this.sel = data.selected.slice();
    this.colorIdx = data.colorPos > 0 ? data.colorPos - 1 : -1;
    // option that picks the photos: color on garments, the amount on the gift card
    this.mediaIdx = data.mediaPos > 0 ? data.mediaPos - 1 : this.colorIdx;
    this.mediaOnly = this.mediaIdx !== this.colorIdx; // gift card: show only the picked amount's card
    this.sizeIdx = data.sizePos > 0 ? data.sizePos - 1 : -1;
    this.idInput = $('[data-aa-id]', root);
    this.priceEl = $('[data-aa-price]', root);
    this.statusEl = $('[data-aa-status]', root);
    this.payBtn = $('[data-aa-paybtn]', root);
    this.media = $('[data-aa-media]', root);
    this.items = $$('.aa-pdp__item', root);
    this.sticky = $('[data-aa-sticky]', root);
    this.sheet = $('[data-aa-sheet]', root);
    this.chart = $('[data-aa-chart]', root);
    this.zoomLayer = $('[data-aa-zoomlayer]', root);
    this.backdrop = $('[data-aa-backdrop]', root);
    this.adding = false;
    this.openLayers = [];
    this.lastColor = this.colorIdx >= 0 ? this.sel[this.colorIdx] : null;

    // arrived via the "style" row: keep the color, but make the shopper choose a size on this garment
    try {
      var su = new URL(window.location.href);
      if (su.searchParams.get('aa_style')) {
        if (this.sizeIdx >= 0) this.sel[this.sizeIdx] = null;
        su.searchParams.delete('aa_style');
        window.history.replaceState({}, '', su.toString());
      }
    } catch (e) { /* ignore */ }

    this.assignMediaColors();
    this.bind();
    this.render(true);
    this.watchSticky();
  }

  var P = Pdp.prototype;

  /* ---------- variant logic ---------- */
  P.resolved = function () {
    var sel = this.sel;
    if (sel.some(function (v) { return v == null; })) return null;
    return this.data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  };

  // variants consistent with the current selection, ignoring option `skip`
  P.matching = function (skip) {
    var sel = this.sel;
    return this.data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return i === skip || sel[i] == null || o === sel[i]; });
    });
  };

  P.colorAvailable = function (value) {
    var ci = this.colorIdx;
    return this.data.variants.some(function (v) { return v.available && v.options[ci] === value; });
  };

  P.firstUnselected = function () {
    for (var i = 0; i < this.sel.length; i++) if (this.sel[i] == null) return i;
    return -1;
  };

  /* ---------- gallery filtering by color ---------- */
  P.assignMediaColors = function () {
    var self = this;
    if (this.mediaIdx < 0) return;
    var mi = this.mediaIdx;
    var values = this.data.options[mi].values;
    var handles = values.map(handleize);
    // media id -> colors of variants whose featured media it is
    var byVariant = {};
    this.data.variants.forEach(function (v) {
      if (v.media == null) return;
      var c = v.options[mi];
      (byVariant[v.media] = byVariant[v.media] || {})[c] = true;
    });
    this.items.forEach(function (it) {
      var key = '-' + (it.getAttribute('data-key') || '').replace(/\s+/g, '-') + '-';
      var best = null, bestLen = 0;
      handles.forEach(function (h, i) {
        if (h && key.indexOf('-' + h + '-') !== -1 && h.length > bestLen) { best = values[i]; bestLen = h.length; }
      });
      if (best == null) {
        var vc = byVariant[it.getAttribute('data-media-id')];
        var names = vc ? Object.keys(vc) : [];
        if (names.length === 1) best = names[0];
      }
      it.__color = best;
    });
  };

  P.filterGallery = function () {
    if (this.mediaIdx < 0 || !this.items.length) return;
    var color = this.sel[this.mediaIdx];
    var matched = this.items.filter(function (it) { return it.__color === color; });
    var show = matched.length ? matched : (this.mediaOnly ? this.items.slice(0, 1) : this.items);
    this.items.forEach(function (it) {
      it.hidden = show.indexOf(it) === -1;
      it.classList.remove('is-detail');
      it.classList.remove('is-hero');
    });
    if (show.length) show[0].classList.add('is-hero');
    // the lead photo spans the gallery, the rest are half-width tiles: keep each img's sizes honest so the browser
    // fetches a sharp enough file (audit R6-02)
    this.items.forEach(function (it) { var im = it.querySelector('img[sizes]'); if (im) im.sizes = it.classList.contains('is-hero') ? HERO_SIZES : TILE_SIZES; });
    if (show.length >= 3) show[show.length - 1].classList.add('is-detail');
    if (this.media) this.media.scrollLeft = 0;
  };

  /* ---------- render ---------- */
  P.render = function (initial) {
    var self = this, d = this.data, v = this.resolved();
    var partial = v || this.matching(-1).filter(function (x) { return x.available; })[0] || this.matching(-1)[0] || d.variants[0];

    // option buttons: pressed + availability
    $$('[data-aa-opt]', this.root).forEach(function (b) {
      var idx = +b.getAttribute('data-aa-opt');
      var val = b.getAttribute('data-value');
      var on = self.sel[idx] === val;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (idx === self.colorIdx) {
        b.classList.toggle('is-out', !self.colorAvailable(val));
      } else {
        var sel = self.sel;
        var avail = d.variants.some(function (x) {
          if (!x.available || x.options[idx] !== val) return false;
          return x.options.every(function (o, i) { return i === idx || sel[i] == null || o === sel[i]; });
        });
        b.classList.toggle('is-out', !avail);
        b.disabled = !avail;
        if (!avail) b.setAttribute('aria-label', val + ', sold out'); else b.removeAttribute('aria-label');
      }
    });

    // "size: medium": spell out the picked value next to each non-color option label
    var self2 = this;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-aa-opt-name]'), function (el) {
      var val = self2.sel[+el.getAttribute('data-aa-opt-name')];
      var txt = val ? sizeWord(val).replace(/^(\$\d+)\.00$/, '$1') : '';
      if (el.textContent !== txt) el.textContent = txt;
    });

    var cn = $('[data-aa-color-name]', this.root);
    if (cn && this.colorIdx >= 0 && this.sel[this.colorIdx]) cn.textContent = this.sel[this.colorIdx].toLowerCase();

    // price
    if (partial && this.priceEl) {
      var html = '<span data-aa-price-now>' + partial.price + '</span>';
      if (partial.compare) html += ' <s class="aa-pdp__compare"><span class="aa-visually-hidden">regular price </span>' + partial.compare + '</s> <span class="aa-pdp__sale">( sale )</span>';
      if (this.priceEl.__html !== html) { this.priceEl.innerHTML = html; this.priceEl.__html = html; }
    }

    // hidden id input
    if (this.idInput && partial) this.idInput.value = (v || partial).id;

    // ATC state
    var label, disabled = false;
    var anyAvailable = d.variants.some(function (x) { return x.available; });
    if (!anyAvailable) { label = 'sold out'; disabled = true; }
    else if (!v) {
      var m = this.matching(-1);
      if (m.length && !m.some(function (x) { return x.available; })) { label = 'sold out'; disabled = true; }
      else {
        var fu = this.firstUnselected();
        label = 'choose ' + chooseWord(fu >= 0 ? d.options[fu].name : 'size');
      }
    }
    else if (!v.available) { label = 'sold out'; disabled = true; }
    else label = 'add to cart';
    this.atcState = { label: label, disabled: disabled };
    $$('[data-aa-atc]', this.root).forEach(function (b) {
      if (!self.adding && !self.justAdded) self.setLabel(b, label);
      b.disabled = disabled;
    });
    if (this.msgFor && v) this.setMsg('');

    // dynamic checkout only for a chosen, available variant
    if (this.payBtn) { this.payBtn.classList.toggle('is-pending', !(v && v.available)); }

    // gallery on color change
    var color = this.mediaIdx >= 0 ? this.sel[this.mediaIdx] : null;
    if (initial || color !== this.lastColor) { this.lastColor = color; this.filterGallery(); }
    // classic tee: the material line follows the picked color's fiber content (audit P-08). Supplier spec (Printify
    // listing for this blank): Athletic Heather 90/10 and other "Heather" colors 52/48 cotton/polyester. Every other
    // color, Asphalt and the Vintage colors included, is 100% cotton (Mike, Oct 15) and keeps the base line.
    var matEl = this.root.querySelector('[data-aa-material]');
    if (matEl) {
      var base = matEl.getAttribute('data-aa-material'), cName = this.colorIdx >= 0 ? String(this.sel[this.colorIdx] || '').toLowerCase() : '';
      var mat = base;
      if (cName === 'athletic heather') mat = '4.2 oz combed ring-spun cotton-poly blend (90% cotton, 10% polyester)';
      else if (/^heather /.test(cName)) mat = '4.2 oz combed ring-spun cotton-poly blend (52% cotton, 48% polyester)';
      if (matEl.textContent !== mat) matEl.textContent = mat;
    }

    // "style" row links: carry the picked color over to the other garment (when it offers it)
    var pickedColor = this.colorIdx >= 0 && this.sel[this.colorIdx] ? String(this.sel[this.colorIdx]).toLowerCase() : '';
    $$('[data-aa-style-link]', this.root).forEach(function (a) {
      var base = a.__aaBase || (a.__aaBase = a.getAttribute('href'));
      var map = a.__aaMap;
      if (!map) { try { map = a.__aaMap = JSON.parse(a.getAttribute('data-colors') || '{}'); } catch (e) { map = a.__aaMap = {}; } }
      if (!a.__aaNorm) { a.__aaNorm = {}; Object.keys(map).forEach(function (k) { a.__aaNorm[normColor(k)] = map[k]; }); }
      var id = pickedColor && (map[pickedColor] || a.__aaNorm[normColor(pickedColor)]);
      a.setAttribute('href', id ? base + '?variant=' + id + '&aa_style=1' : base);
    });

    // URL
    if (v && (!initial || this.data.urlVariant)) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // back-in-stock form: only for a chosen variant that is genuinely unavailable
    var soldOut = !!(v && !v.available);
    $$('[data-aa-notify]', this.root).forEach(function (f) {
      if (soldOut && f.__vid !== v.id) {
        f.__vid = v.id;
        var m = $('[data-aa-notifymsg]', f); if (m) { m.textContent = ''; m.classList.remove('is-err'); }
        f.classList.remove('is-done');
      }
      if (!soldOut) f.__vid = null;
      f.hidden = !soldOut;
    });

    this.highlightChart();
  };

  /* ---------- back-in-stock ("notify me") via Klaviyo's client API ---------- */
  var KLAVIYO_COMPANY = 'TcWas7';
  P.notify = function (form) {
    var v = this.resolved();
    var input = $('input[name="email"]', form), msg = $('[data-aa-notifymsg]', form), btn = $('button', form);
    var email = (input.value || '').trim();
    function say(t, err) { msg.textContent = t; msg.classList.toggle('is-err', !!err); }
    if (!v || v.available) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { input.setAttribute('aria-invalid', 'true'); say('please enter a valid email.', true); input.focus(); return; }
    input.removeAttribute('aria-invalid');
    if (form.__busy) return;
    form.__busy = true; btn.disabled = true; say('');
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
      } })
    }).then(function (r) {
      if (!(r.status >= 200 && r.status < 300)) throw new Error('bad status');
      form.classList.add('is-done');
      say('we\u2019ll email you when it\u2019s back.');
    }).catch(function () {
      say('sorry, that didn\u2019t go through. please try again.', true);
    }).then(function () { form.__busy = false; btn.disabled = false; });
  };

  P.setMsg = function (text) {
    this.msgFor = !!text;
    $$('[data-aa-msg]', this.root).forEach(function (m) { m.textContent = text; });
  };

  /* ---------- size chart highlight ---------- */
  P.selectedSize = function () {
    return this.sizeIdx >= 0 && this.sel[this.sizeIdx] ? String(this.sel[this.sizeIdx]) : '';
  };
  P.highlightChart = function () {
    if (!this.chart) return;
    var size = this.selectedSize().toLowerCase().replace(/\s+/g, '');
    $$('.aa-size-chart tr[data-size]', this.chart).forEach(function (tr) {
      var s = (tr.getAttribute('data-size') || '').toLowerCase().replace(/\s+/g, '');
      tr.classList.toggle('is-selected', !!size && s === size);
    });
  };

  /* ---------- size chart units + sleeve definition ---------- */
  var EIGHTHS = ['', '\u215B', '\u00BC', '\u215C', '\u00BD', '\u215D', '\u00BE', '\u215E'];
  function fmtUnit(inches, unit) {
    if (unit === 'cm') return String(Math.round(inches * 2.54 * 2) / 2);
    var e = Math.round(inches * 8), whole = Math.floor(e / 8), frac = EIGHTHS[e % 8];
    return (whole || !frac ? String(whole) : '') + frac;
  }
  function readUnit() {
    try { return localStorage.getItem('aa-size-unit') === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }
  P.applyUnit = function (unit, save) {
    if (!this.chart) return;
    if (save) { try { localStorage.setItem('aa-size-unit', unit); } catch (e) { /* private mode */ } }
    $$('.aa-size-chart', this.chart).forEach(function (c) { c.setAttribute('data-unit', unit); });
    $$('td[data-in]', this.chart).forEach(function (td) {
      var n = parseFloat(td.getAttribute('data-in'));
      if (!isNaN(n)) td.textContent = fmtUnit(n, unit);
    });
    $$('[data-aa-unit]', this.chart).forEach(function (b) {
      b.setAttribute('aria-checked', String(b.getAttribute('data-aa-unit') === unit));
    });
    this.highlightChart();
  };
  P.syncChartDefs = function () {
    if (!this.chart) return;
    var hasSleeve = $$('th', this.chart).some(function (th) { return /sleeve/i.test(th.textContent); });
    $$('[data-aa-def]', this.chart).forEach(function (d) {
      if (/sleeve/i.test(d.getAttribute('data-aa-def'))) d.hidden = !hasSleeve;
    });
    // hide chart rows for sizes this product isn't sold in (e.g. a 5XL row on a design that stops at 4XL)
    if (this.sizeIdx < 0 || !this.data.variants) return;
    var norm = function (s) { s = String(s || '').toUpperCase().replace(/\s+/g, ''); var m = s.match(/^(X{2,})L$/); return m ? m[1].length + 'XL' : s; };
    var idx = this.sizeIdx, sold = {};
    this.data.variants.forEach(function (v) { if (v.options) sold[norm(v.options[idx])] = true; });
    $$('tr', this.chart).forEach(function (tr) {
      var c = tr.cells && tr.cells[0]; if (!c || c.tagName === 'TH' && tr.parentNode.tagName === 'THEAD') return;
      var k = norm(c.textContent);
      if (/^(\d?X{0,3}S|M|\d?X{0,3}L)$/.test(k)) tr.hidden = !sold[k];
    });
  };

  /* ---------- add to cart ---------- */
  P.atc = function (ctx) {
    var self = this, v = this.resolved();
    if (this.adding) return;
    if (!v) {
      if (ctx === 'sticky' && isMobile() && this.sheet) { this.openLayer(this.sheet); return; }
      var fu = this.firstUnselected();
      this.setMsg('please choose ' + chooseWord(fu >= 0 ? this.data.options[fu].name : 'size') + ' first.');
      return;
    }
    if (!v.available) return;
    // gift card recipient (Shopify native fields), only when the box is ticked
    var gcr = null, gbox = this.root.querySelector('[data-aa-gcr-on]');
    if (gbox && gbox.checked) {
      var gerr = this.root.querySelector('[data-aa-gcr-err]');
      var gfail = function (msg, field) { if (gerr) { gerr.textContent = msg; gerr.hidden = false; } if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); } };
      if (gerr) { gerr.hidden = true; gerr.textContent = ''; }
      var em = this.root.querySelector('[data-aa-gcr-email]');
      if (em) em.removeAttribute('aria-invalid');
      if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((em.value || '').trim())) { gfail('please enter the recipient\u2019s email.', em); return; }
      // send date: blank = right away; otherwise today .. +90 days (typed dates skip the picker's min/max; audit R2-02)
      var dt = this.root.querySelector('[data-aa-gcr-date]');
      if (dt) {
        dt.removeAttribute('aria-invalid');
        var dv = (dt.value || '').trim();
        if (dv) {
          var t = new Date(); var today = t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2);
          var mx = new Date(t.getTime() + 90 * 86400000); var maxd = mx.getFullYear() + '-' + ('0' + (mx.getMonth() + 1)).slice(-2) + '-' + ('0' + mx.getDate()).slice(-2);
          if (!/^\d{4}-\d{2}-\d{2}$/.test(dv) || dv < today) { gfail('please choose today or a later date, or leave it blank to send right away.', dt); return; }
          if (dv > maxd) { gfail('the latest send date is 90 days from today.', dt); return; }
        }
      }
      gcr = {};
      $$('[data-aa-gcr] [name^="properties["]', this.root).forEach(function (f) {
        if (f.type === 'checkbox') { if (f.checked) gcr['__shopify_send_gift_card_to_recipient'] = 'on'; return; }
        var k = f.name.slice(11, -1), val = (f.value || '').trim();
        if (k === '__shopify_offset') val = String(new Date().getTimezoneOffset());
        if (val) gcr[k] = val;
      });
    }
    // gift a design + from: sent whether or not the card goes straight to the recipient
    $$('[data-aa-gd] [name^="properties["], [data-aa-gd-from] [name^="properties["]', this.root).forEach(function (f) {
      var k = f.name.slice(11, -1), val = (f.value || '').trim();
      if (val) { gcr = gcr || {}; gcr[k] = val; }
    });
    this.setMsg('');
    this.adding = true;
    this.clearAdded();
    // instant feedback: the label changes on the click itself, before any network round trip
    $$('[data-aa-atc]', this.root).forEach(function (b) { b.classList.add('is-loading'); self.setLabel(b, 'adding\u2026'); });

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [Object.assign({ id: v.id, quantity: 1 }, gcr ? { properties: gcr } : {})] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.json.description || res.json.message || 'sorry, that could not be added.');
      // the moment /cart/add.js resolves: tick, refresh event, and slide the drawer open right away
      // (the stock drawer fills in the new line items when its own cart fetch lands)
      self.adding = false;
      self.showAdded();
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      self.openCartNow();
      if (self.sheet && self.sheet.classList.contains('is-open')) self.closeLayer(self.sheet, true);
      if (self.statusEl) self.statusEl.textContent = 'added to cart';
    }).catch(function (err) {
      self.finishAdd();
      self.setMsg(String(err && err.message || 'sorry, that could not be added.').toLowerCase());
    });
  };
  P.finishAdd = function () {
    this.adding = false;
    $$('[data-aa-atc]', this.root).forEach(function (b) { b.classList.remove('is-loading'); });
    this.render(false);
  };
  // label swap with a short fade (.15s, see .aa-pdp__atc [data-aa-atc-label] in aa-product.css)
  P.setLabel = function (btn, text) {
    var l = $('[data-aa-atc-label]', btn);
    if (!l || l.textContent === text) return;
    l.textContent = text;
    l.classList.remove('is-swap');
    void l.offsetWidth;
    l.classList.add('is-swap');
  };
  // open the stock cart drawer through its own header toggle (same code path as a click on "cart")
  P.openCartNow = function () {
    if (document.body.classList.contains('js-drawer-open-cart')) return;
    var t = $$('[data-cart-drawer-toggle]').filter(function (el) { return !el.closest('[data-cart-drawer], #cart-drawer'); })[0];
    if (t) t.click();
  };
  // "added" + a hand-drawn tick (aa-loop.js pen) for 1.2s on every add-to-cart button, then restore
  P.showAdded = function () {
    var self = this;
    this.justAdded = true;
    $$('[data-aa-atc]', this.root).forEach(function (b) {
      b.classList.remove('is-loading');
      b.classList.add('is-added');
      self.setLabel(b, 'added');
      var tk = $('.aa-pdp__tick', b);
      if (!tk) {
        tk = document.createElement('span');
        tk.className = 'aa-pdp__tick';
        tk.setAttribute('aria-hidden', 'true');
        tk.innerHTML = '<svg class="aa-loop aa-tick" data-color="#fff"></svg>';
        b.insertBefore(tk, $('[data-aa-atc-label]', b));
      }
      var svg = tk.firstChild;
      if (window.aaTick) window.aaTick(svg);
    });
    clearTimeout(this.addedTimer);
    this.addedTimer = setTimeout(function () { self.clearAdded(); }, 1200);
  };
  P.clearAdded = function () {
    clearTimeout(this.addedTimer);
    if (!this.justAdded) return;
    this.justAdded = false;
    $$('[data-aa-atc]', this.root).forEach(function (b) {
      b.classList.remove('is-added');
      var tk = $('.aa-pdp__tick', b);
      if (tk) tk.remove();
    });
    this.render(false);
  };

  /* ---------- layers (drawer, sheet, zoom) ---------- */
  P.lock = function () {
    document.documentElement.style.overflow = this.openLayers.length ? 'hidden' : '';
  };
  P.openLayer = function (layer, opener) {
    if (!layer || layer.classList.contains('is-open')) return;
    layer.__opener = opener || document.activeElement;
    if (layer === this.zoomLayer) layer.hidden = false;
    layer.setAttribute('aria-hidden', 'false');
    // force reflow so the transition runs
    void layer.offsetWidth;
    layer.classList.add('is-open');
    if (layer !== this.zoomLayer && this.backdrop) this.backdrop.classList.add('is-open');
    this.openLayers.push(layer);
    this.lock();
    if (layer === this.chart) { this.syncChartDefs(); this.applyUnit(readUnit(), false); }
    var target = $('[data-aa-close]', layer) || layer;
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 30);
  };
  P.closeLayer = function (layer, skipFocus) {
    if (!layer || !layer.classList.contains('is-open')) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    if (layer === this.zoomLayer) layer.hidden = true;
    this.openLayers = this.openLayers.filter(function (l) { return l !== layer; });
    if (this.backdrop && !this.openLayers.some(function (l) { return l !== this.zoomLayer; }, this)) this.backdrop.classList.remove('is-open');
    this.lock();
    var op = layer.__opener;
    if (!skipFocus && op && op.focus) { try { op.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  };
  P.closeTop = function () {
    var top = this.openLayers[this.openLayers.length - 1];
    if (top) this.closeLayer(top);
    return !!top;
  };

  P.openZoom = function (startItem) {
    var list = $('[data-aa-zoomlist]', this.root);
    if (!list) return;
    list.innerHTML = '';
    var targetImg = null;
    this.items.filter(function (it) { return !it.hidden; }).forEach(function (it) {
      var img = document.createElement('img');
      img.src = it.getAttribute('data-zoom');
      img.alt = it.getAttribute('data-alt') || '';
      img.loading = 'lazy';
      list.appendChild(img);
      if (it === startItem) targetImg = img;
    });
    this.openLayer(this.zoomLayer);
    if (targetImg) setTimeout(function () { targetImg.scrollIntoView({ block: 'start' }); }, 40);
  };

  /* ---------- sticky bar ---------- */
  P.watchSticky = function () {
    var self = this;
    var mainBtn = $('[data-aa-atc="main"]', this.root);
    if (!this.sticky || !mainBtn) return;
    function update() {
      var r = mainBtn.getBoundingClientRect();
      var show = r.bottom < 0 || r.top > window.innerHeight - 8;
      self.sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('aa-sticky-on', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  /* ---------- events ---------- */
  P.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target;
      var opt = t.closest('[data-aa-opt]');
      if (opt && root.contains(opt)) {
        if (opt.disabled) return;
        var idx = +opt.getAttribute('data-aa-opt');
        self.sel[idx] = opt.getAttribute('data-value');
        self.setMsg('');
        self.render(false);
        return;
      }
      var atc = t.closest('[data-aa-atc]');
      if (atc) { self.atc(atc.getAttribute('data-aa-atc')); return; }

      var img = t.closest('.aa-pdp__item');
      if (img && !t.closest('a')) { self.openZoom(img); return; }
      if (t.closest('[data-aa-zoom]')) {
        var first = self.items.filter(function (it) { return !it.hidden; })[0];
        // open at the slide currently in view on mobile
        var m = self.media, cur = first;
        if (m) {
          var vis = self.items.filter(function (it) { return !it.hidden; });
          var best = 1e9;
          vis.forEach(function (it) { var d = Math.abs(it.offsetLeft - m.scrollLeft); if (d < best) { best = d; cur = it; } });
        }
        self.openZoom(cur);
        return;
      }
      var ng = t.closest('[data-aa-notifygo]');
      if (ng) { self.notify(ng.closest('[data-aa-notify]')); return; }
      var ub = t.closest('[data-aa-unit]');
      if (ub) { self.applyUnit(ub.getAttribute('data-aa-unit'), true); return; }
      var co = t.closest('[data-aa-chart-open]');
      if (co) { self.openLayer(self.chart, co); return; }

      var cl = t.closest('[data-aa-close]');
      if (cl) { var layer = cl.closest('[data-aa-chart],[data-aa-sheet],[data-aa-zoomlayer]'); self.closeLayer(layer); return; }

      var acc = t.closest('[data-aa-acc]');
      if (acc) {
        var open = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', open ? 'false' : 'true');
        var body = document.getElementById(acc.getAttribute('aria-controls'));
        if (body) body.classList.toggle('is-open', !open); // grid-template-rows 0fr -> 1fr, see aa-product.css
        return;
      }
      // custom.js re-renders the chart (and drops our highlight) when the unit toggles
      if (t.closest('.aa-unit-toggle')) setTimeout(function () { self.highlightChart(); }, 30);
    });

    // not a <form>: the main copy sits inside the product form, and forms can't nest
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.closest) return;
      var f = e.target.closest('[data-aa-notify]');
      if (!f) return;
      e.preventDefault();
      self.notify(f);
    });

    if (this.backdrop) this.backdrop.addEventListener('click', function () {
      var l = self.openLayers.filter(function (x) { return x !== self.zoomLayer; }).pop();
      if (l) self.closeLayer(l);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !self.openLayers.length) return;
      var layer = self.openLayers[self.openLayers.length - 1];
      var f = $$(FOCUSABLE, layer).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!layer.contains(document.activeElement)) { first.focus(); e.preventDefault(); }
      else if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.openLayers.length && document.body.contains(root)) { self.closeTop(); }
    });
  };


  /* ---------- recently viewed (read by sections/aa-pdp-recent.liquid) ---------- */
  var RECENT_KEY = 'aa_recent_handles';
  function recordViewed(handle) {
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(list)) list = [];
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 8);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  /* ---------- delivery estimate: business days only, cutoff in the store timezone ---------- */
  var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  function storeNow(tz) {
    var d = new Date();
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(d).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
      if (parts.year && parts.month && parts.day) return { y: parts.year, m: parts.month, d: parts.day, h: parts.hour % 24 };
    } catch (e) {}
    return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), h: d.getHours() };
  }
  function isBiz(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6; }
  function addBiz(dt, n) {
    var x = new Date(dt.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; }
    return x;
  }
  function fmtDate(dt) { return MONTHS[dt.getUTCMonth()] + ' ' + dt.getUTCDate(); }
  function initDelivery(root) {
    var el = $('[data-aa-deliv]', root);
    if (!el) return;
    var num = function (k, dflt) { var v = parseInt(el.getAttribute(k), 10); return isNaN(v) ? dflt : v; };
    var proc = num('data-process', 2), smin = num('data-ship-min', 3), smax = Math.max(num('data-ship-max', 6), smin), cutoff = num('data-cutoff', 14);
    var now = storeNow(el.getAttribute('data-tz') || 'America/New_York');
    var day = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var late = now.h >= cutoff;
    var start = day;
    if (late || !isBiz(day)) { start = addBiz(day, 1); late = true; }
    var ship = addBiz(start, proc);
    var a = addBiz(ship, smin), b = addBiz(ship, smax);
    var tpl = (late ? el.getAttribute('data-text-late') : el.getAttribute('data-text')) || 'arrives {start} – {end}';
    var t = $('[data-aa-deliv-text]', el);
    if (!t) return;
    t.textContent = tpl.replace('{start}', fmtDate(a)).replace('{end}', fmtDate(b)).toLowerCase();
    el.hidden = false;
  }
  function initAll() { $$('[data-aa-pdp]').forEach(function (r) { new Pdp(r); initDelivery(r); recordViewed(r.getAttribute('data-handle')); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* Shop Pay skips our form fields (recipient, picked designs, "from"), so it's hidden whenever any of them is in use */
window.aaSyncPay = function (root) {
  if (!root) return;
  var pay = root.querySelector('[data-aa-paybtn]'); if (!pay) return;
  var on = root.querySelector('[data-aa-gcr-on]'), picks = root.querySelector('[data-aa-gd-handles]'), from = root.querySelector('[data-aa-gd-from] input');
  pay.classList.toggle('is-gcr-hidden', !!((on && on.checked) || (picks && picks.value) || (from && from.value.trim())));
};
document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('[data-aa-gd-from]')) window.aaSyncPay(e.target.closest('.aa-pdp')); });

/* gift card recipient: show the fields when the box is ticked; live character count */
(function () {
  document.addEventListener('change', function (e) {
    var on = e.target.closest && e.target.closest('[data-aa-gcr-on]'); if (!on) return;
    var box = on.closest('[data-aa-gcr]'), f = box.querySelector('[data-aa-gcr-fields]'); f.hidden = !on.checked;
    var em0 = f.querySelector('[data-aa-gcr-email]'); if (em0) { em0.required = on.checked; em0.setAttribute('aria-required', on.checked ? 'true' : 'false'); }
    // clear old errors when the box is unticked (audit R2), and keep Shop Pay out of the recipient path: it skips these checks
    if (!on.checked) { var er = box.querySelector('[data-aa-gcr-err]'); if (er) { er.hidden = true; er.textContent = ''; } [].forEach.call(box.querySelectorAll('[aria-invalid]'), function (x) { x.removeAttribute('aria-invalid'); }); }
    var root = on.closest('.aa-pdp'); window.aaSyncPay(root);
    var msg = root && root.querySelector('[data-aa-status]'); if (msg && !on.checked) msg.textContent = '';
    if (on.checked) { var em = f.querySelector('[data-aa-gcr-email]'); if (em) em.focus(); }
  });
  document.addEventListener('input', function (e) {
    var m = e.target.closest && e.target.closest('[data-aa-gcr-msg]'); if (!m) return;
    var c = m.parentNode.querySelector('[data-aa-gcr-count]'); if (c) c.textContent = m.value.length + ' / 200';
  });
})();

/* gift a design: search the archive, pick several designs, the card amount follows (gift card product only) */
(function () {
  var MAX = 8;
  function usd(c) { c = +c || 0; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function short(t) { return String(t).replace(/ (Kids Classic Tee|Women's Classic Tee|Classic Tee|T-Shirt|Vintage Heavyweight Tee|Vintage Heavyweight T-Shirt|Vintage Long Sleeve( Tee)?|Classic Crewneck|Crewneck Sweatshirt|Classic Hoodie|Hoodie|Canvas Tote|Cotton Canvas Tote Bag|Tote)$/i, ''); }
  function garment(t, type) {
    var s = (String(type || '') + ' ' + String(t || '')).toLowerCase();
    if (/bags|tote/.test(s)) return 'tote'; if (/hoodie|hooded/.test(s)) return 'classic hoodie'; if (/sweat|crewneck/.test(s)) return 'classic crewneck'; if (/long sleeve/.test(s)) return 'vintage long sleeve'; if (/kids/.test(s)) return 'kids classic tee'; if (/heavyweight/.test(s)) return 'heavyweight tee'; return 'classic tee';
  }
  function init(box) {
    if (box.__aaGd) return; box.__aaGd = true;
    var root = box.closest('.aa-pdp'), q = box.querySelector('[data-aa-gd-q]'), res = box.querySelector('[data-aa-gd-res]');
    var list = box.querySelector('[data-aa-gd-picked]'), sum = box.querySelector('[data-aa-gd-sum]');
    var names = box.querySelector('[data-aa-gd-names]'), handles = box.querySelector('[data-aa-gd-handles]');
    var picks = [], timer = 0, ctl = null, manual = false;
    // a screen-reader note for search results ("no designs named x. 8 suggestions.")
    var live = document.createElement('p'); live.className = 'aa-sr-only'; live.setAttribute('aria-live', 'polite'); box.appendChild(live);
    function amounts() {
      return [].slice.call(root.querySelectorAll('.aa-pdp__chips--amount .aa-pdp__chip')).map(function (b) {
        return { b: b, c: Math.round(parseFloat(String(b.getAttribute('data-value')).replace(/[^0-9.]/g, '')) * 100) };
      }).filter(function (x) { return x.c > 0; }).sort(function (a, b) { return a.c - b.c; });
    }
    function render() {
      list.innerHTML = picks.map(function (p, i) {
        return '<li class="aa-gd__pk"><span class="aa-gd__pi">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="40" height="40">' : '') + '</span>' +
          '<span class="aa-gd__pn">' + esc(short(p.title).toLowerCase()) + '<small>' + garment(p.title, p.type) + ' · ' + usd(p.price) + '</small></span>' +
          '<button type="button" class="aa-gd__rm" data-aa-gd-rm="' + i + '" aria-label="remove ' + esc(short(p.title)) + '">&times;</button></li>';
      }).join('');
      names.value = picks.map(function (p) { return short(p.title); }).join(' · ');
      handles.value = picks.map(function (p) { return p.handle; }).join(',');
      if (window.aaSyncPay) window.aaSyncPay(root);
      [].forEach.call(box.querySelectorAll('[data-aa-gd-add]'), function (b) { b.disabled = picks.some(function (p) { return p.handle === b.getAttribute('data-handle'); }) || picks.length >= MAX; });
      // the amount follows the picks until the buyer chooses one by hand; after that it stays theirs
      var cnt = box.querySelector('[data-aa-gd-count]'); if (cnt) cnt.textContent = picks.length ? '( ' + picks.length + ' picked )' : '( optional )';
      if (picks.length && !manual) { var fit = cover(); if (fit && fit.b.getAttribute('aria-pressed') !== 'true') fit.b.click(); }
      summary();
    }
    function total() { return picks.reduce(function (a, p) { return a + (+p.price || 0); }, 0); }
    function cover() { var opts = amounts(), t = total(); return opts.filter(function (x) { return x.c >= t; })[0] || opts[opts.length - 1]; }
    function selected() { return amounts().filter(function (x) { return x.b.getAttribute('aria-pressed') === 'true' || x.b.classList.contains('is-active'); })[0]; }
    // always describes the card that will actually be added
    function summary() {
      if (!picks.length) { sum.hidden = true; sum.innerHTML = ''; return; }
      var t = total(), cur = selected(), n = picks.length + (picks.length === 1 ? ' design' : ' designs');
      var txt = n + ' · about ' + usd(t) + ' at classic sizes, before shipping and tax';
      if (cur && cur.c >= t) txt += ' · ' + usd(cur.c) + ' card' + (cur.c > t ? ', so about ' + usd(cur.c - t) + ' left over' : '') + '.';
      else if (cur) {
        var fit = cover();
        txt += ' · the ' + usd(cur.c) + ' card covers part of that; they pay the rest at checkout.';
        if (fit && fit.c > cur.c) txt = esc(txt) + ' <button type="button" class="aa-gd__fit" data-aa-gd-fit>set the card to ' + usd(fit.c) + '</button>';
      }
      sum.hidden = false;
      if (txt.indexOf('<button') > -1) sum.innerHTML = txt; else sum.textContent = txt;
    }
    function add(p) {
      if (!p || !p.handle || picks.length >= MAX || picks.some(function (x) { return x.handle === p.handle; })) return;
      picks.push(p); render();
    }
    function close() { res.hidden = true; q.setAttribute('aria-expanded', 'false'); }
    function search(term) {
      if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide', { signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.json(); }).then(function (j) {
          var ps = ((j.resources && j.resources.results && j.resources.results.products) || []).filter(function (p) { return !/gift card/i.test(p.title); });
          var words = term.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
          var named = ps.some(function (p) { var h = (p.title + ' ' + p.handle).toLowerCase(); return words.every(function (w) { return h.indexOf(w) > -1; }); });
          var head = named ? '' : '<li class="aa-gd__none aa-ui">( no designs named \u201c' + esc(term) + '\u201d' + (ps.length ? ' · closest matches' : '. try a composer or a film') + ' )</li>';
          live.textContent = named ? ps.length + (ps.length === 1 ? ' design' : ' designs') + ' found.' : 'no designs named ' + term + '.' + (ps.length ? ' ' + ps.length + ' suggestions.' : '');
          if (!ps.length) { res.innerHTML = head; }
          else res.innerHTML = head + ps.map(function (p) {
            var cents = Math.round(parseFloat(p.price_min || p.price) * 100);
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            return '<li><button type="button" class="aa-gd__opt" data-aa-gd-add data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" data-type="' + esc(p.type || '') + '" data-price="' + cents + '" data-img="' + esc(img) + '">' +
              (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" width="40" height="40">' : '') + '<span>' + esc(short(p.title).toLowerCase()) + '</span><small>' + garment(p.title, p.type) + ' · ' + usd(cents) + '</small></button></li>';
          }).join('');
          res.hidden = false; q.setAttribute('aria-expanded', 'true');
          render();
        }).catch(function () {});
    }
    q.addEventListener('input', function () { clearTimeout(timer); var t = q.value.trim(); if (t.length < 2) { close(); return; } timer = setTimeout(function () { search(t); }, 180); });
    function opts() { return [].slice.call(res.querySelectorAll('[data-aa-gd-add]:not([disabled])')); }
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter') { e.preventDefault(); var f = opts()[0]; if (f) f.click(); }
      if (e.key === 'ArrowDown' && !res.hidden) { var o = opts(); if (o[0]) { e.preventDefault(); o[0].focus(); } }
    });
    res.addEventListener('keydown', function (e) {
      var o = opts(), i = o.indexOf(document.activeElement); if (i < 0) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); (o[i + 1] || o[i]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (i ? o[i - 1] : q).focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); q.focus(); }
    });
    // a hand-picked amount sticks; any change of amount (hand or auto) refreshes the summary
    if (root) root.addEventListener('click', function (e) {
      var chip = e.target.closest('.aa-pdp__chips--amount .aa-pdp__chip'); if (!chip) return;
      if (e.isTrusted) manual = true;
      setTimeout(summary, 0);
    });
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-aa-gd-add]');
      if (a) { add({ handle: a.getAttribute('data-handle'), title: a.getAttribute('data-title'), type: a.getAttribute('data-type') || '', price: +a.getAttribute('data-price'), img: a.getAttribute('data-img') }); if (a.classList.contains('aa-gd__opt')) { q.value = ''; close(); q.focus(); } return; }
      var fitb = e.target.closest('[data-aa-gd-fit]');
      if (fitb) { var f = cover(); manual = false; if (f) f.b.click(); setTimeout(summary, 0); return; }
      var r = e.target.closest('[data-aa-gd-rm]');
      if (r) { picks.splice(+r.getAttribute('data-aa-gd-rm'), 1); render(); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-aa-gd]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* gift card amounts: a caption for what the chosen amount buys, a "more amounts" fold, and a custom amount box that
   selects the matching amount (amounts are variants; any amount that isn't one gets the two nearest offered) */
(function () {
  function usd(c) { c = +c || 0; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function init(root) {
    var group = root.querySelector('.aa-pdp__chips--amount'); if (!group || group.__aaAmt) return; group.__aaAmt = true;
    var cap = root.querySelector('[data-aa-amt-cap]'), more = root.querySelector('[data-aa-amt-more]'), box = root.querySelector('[data-aa-amt-custom]');
    var input = root.querySelector('[data-aa-amt-input]'), set = root.querySelector('[data-aa-amt-set]'), note = root.querySelector('[data-aa-amt-note]');
    function chips() { return [].slice.call(group.querySelectorAll('.aa-pdp__chip')); }
    function update() {
      var on = chips().filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      if (on) on.hidden = false;
      if (cap) cap.textContent = on && on.getAttribute('data-caption') ? usd(on.getAttribute('data-cents')) + ' covers ' + on.getAttribute('data-caption') + ', before shipping and tax.' : ''; // audit P-06
    }
    function open() {
      chips().forEach(function (b) { b.hidden = false; });
      if (box) box.hidden = false;
      if (more) { more.setAttribute('aria-expanded', 'true'); more.hidden = true; }
    }
    if (more) more.addEventListener('click', function () { open(); if (input) input.focus(); });
    else if (box) box.hidden = false;
    function pick(c) {
      var b = chips().filter(function (x) { return +x.getAttribute('data-cents') === c; })[0];
      if (b) { b.hidden = false; b.click(); if (note) note.textContent = ''; return true; }
      return false;
    }
    function useAmount() {
      var c = Math.round(parseFloat(String(input.value).replace(/[^0-9.]/g, '')) * 100);
      if (!c) { if (note) note.textContent = 'type an amount in dollars.'; return; }
      if (pick(c)) return;
      var all = chips().map(function (x) { return +x.getAttribute('data-cents'); }).sort(function (a, b) { return a - b; });
      var lo = all.filter(function (x) { return x < c; }).pop(), hi = all.filter(function (x) { return x > c; })[0];
      if (!note) return;
      note.innerHTML = 'we can do ' + [lo, hi].filter(Boolean).map(function (x) { return '<button type="button" data-aa-amt-pick="' + x + '">' + usd(x) + '</button>'; }).join(' or ') + '.';
    }
    if (set) set.addEventListener('click', useAmount);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); useAmount(); } });
    if (note) note.addEventListener('click', function (e) { var b = e.target.closest('[data-aa-amt-pick]'); if (b) pick(+b.getAttribute('data-aa-amt-pick')); });
    root.addEventListener('click', function (e) { if (e.target.closest('.aa-pdp__chips--amount .aa-pdp__chip')) setTimeout(update, 0); });
    update();
  }
  function boot() { [].forEach.call(document.querySelectorAll('.aa-pdp--gift'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
